import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import ReCAPTCHA from 'react-google-recaptcha';
import '../components/Contact.css';
import PageHeader from '../components/PageHeader';
import {
  RiPhoneLine,
  RiMailLine,
  RiMapPinLine,
  RiTimeLine,
  RiToolsFill,
  RiMessage2Line
} from 'react-icons/ri';


const Contact = () => {
  const form = useRef();
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);

  const onCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setConfirmationMessage('');
    setErrorMessage('');

    if (!captchaValue) {
      setErrorMessage('❌ Please complete the CAPTCHA before submitting.');
      return;
    }

    emailjs.sendForm(
      'service_vgbb0cl',
      'template_jbm270t',
      form.current,
      'sM9CY_sGBvdqX7eP8'
    )
      .then(() => {
        const formData = new FormData(form.current);
        const userEmail = formData.get('user_email');
        const userName = formData.get('user_name');

        emailjs.send(
          'service_vgbb0cl',
          'template_880obwp',
          {
            user_email: userEmail,
            user_name: userName
          },
          'sM9CY_sGBvdqX7eP8'
        )
          .then(() => {
            setConfirmationMessage('✅ Message sent successfully! Confirmation email sent.');
            setErrorMessage('');
            form.current.reset();
            setCaptchaValue(null); // reset captcha
          })
          .catch((error) => {
            console.error('Error sending confirmation email:', error.text);
            setConfirmationMessage('✅ Message sent! But failed to send confirmation email.');
            setErrorMessage('');
            form.current.reset();
            setCaptchaValue(null);
          });
      })
      .catch((error) => {
        console.error('Error sending email:', error.text);
        setErrorMessage('❌ Failed to send message. Please try again later.');
        setConfirmationMessage('');
      });
  };

  const breadcrumb = [
    { label: 'Home', link: '/' },
    { label: 'Contact' }
  ];

  return (
    <>
      <PageHeader
        icon={<RiMessage2Line size={35} color="#ffffff" />}
        title="Contact Us"
        subtitle="We’re here to help — let's start a conversation."
        breadcrumb={breadcrumb}
      />

      <section className="contact-page">
        <div className="contact-container">
          <div className="get-in-touch-card">
            <h2 className="get-in-touch-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <RiMapPinLine color="#38bdf8" /> Get in Touch
            </h2>
            <p className="get-in-touch-subtext">
              Whether you're looking for a digital solution, partnership, or need technical asisstance — we're here to connect and collaborate.
            </p>
            <ul className="get-in-touch-list">
              <li><h3>Novacrest system inc.</h3><strong></strong></li>
              <li>
                <strong><RiPhoneLine style={{ size: '30px', marginRight: '8px', color: '#38bdf8' }} /></strong>
                +1 (800) 123-4567
              </li>
              <li>
                <strong><RiMailLine style={{ size: '30px', marginRight: '8px', color: '#38bdf8' }} /></strong>
                contact@novacrest.ca
              </li>
              <li>
                <strong><RiMapPinLine style={{ size: '30px', marginRight: '8px', color: '#38bdf8' }} /></strong>
                5266 Kimball Crescent SW, Edmonton <br />
                Alberta, T6W 4Z3
              </li>
              <li>
                <strong><RiTimeLine style={{ size: '30px', marginRight: '8px', color: '#38bdf8' }} /></strong>
                Mon - Fri: 9am - 6pm
              </li>
              <li>
                <strong><RiToolsFill style={{ size: '30px', marginRight: '8px', color: '#38bdf8' }} /></strong>
                24/7 Dedicated Support
              </li>
            </ul>
          </div>


          <form className="contact-form" ref={form} onSubmit={sendEmail}>
            <h3>Send Us a Message</h3>
            <input type="text" name="user_name" placeholder="Your Name" required />
            <input type="email" name="user_email" placeholder="Your Email" required />
            <input type="text" name="user_subject" placeholder="Subject" required />
            <textarea name="user_message" placeholder="Your Message" required></textarea>

            {/* Google reCAPTCHA */}
            <ReCAPTCHA
              sitekey="6LevZ0ArAAAAAF9LQri_Ra0HSJKsnUNa2UlCuFDo" // 🔐 Replace with your actual site key
              onChange={onCaptchaChange}
            />

            <button type="submit">Send Message</button>

            {/* Confirmation message */}
            {confirmationMessage && (
              <div style={{
                marginTop: '15px',
                padding: '15px',
                backgroundColor: '#d1fae5',
                color: '#065f46',
                border: '1px solid #10b981',
                borderRadius: '8px',
                fontWeight: '600',
              }}>
                {confirmationMessage}
              </div>
            )}

            {/* Error message */}
            {errorMessage && (
              <div style={{
                marginTop: '15px',
                padding: '15px',
                backgroundColor: '#fee2e2',
                color: '#991b1b',
                border: '1px solid #ef4444',
                borderRadius: '8px',
                fontWeight: '600',
              }}>
                {errorMessage}
              </div>
            )}
          </form>
        </div>


        <div className="map-section">
          <h3>📍 Our Office Location</h3>
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2377.6803528306855!2d-113.64085312300904!3d53.420542569168994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x539ff5b00cf985fb%3A0xe35343d07f81c36!2s5266%20Kimball%20Crois.%20SW%2C%20Edmonton%2C%20AB%2C%20Canada!5e0!3m2!1sen!2smy!4v1749154336133!5m2!1sen!2smy"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Contact;